<template>
	<div id="Messages" class="box" :key="rerenderCount">
		<div v-if="display_messages">
			<h2>Messages From the SMF Team</h2>
			<p><strong>Welcome to our online system!</strong> This allows you to view all your SMF items online and easily manage them yourself. Each ticket needs to be associated with a unique user account, name, and email address.  Please check out our <a href="https://shambhalamusicfestival.com/tickets/#electronicticketingfaq" target="_blank"><strong>Ticket FAQs</strong></a> for helpful information on everything you need to know!</p>
			<p v-if="HasLodgingNoTickets" class="error"><strong>Hey you! We see that you have a ShambhaLodging package but no tickets. This is a reminder that ShambhaLodging packages do not include tickets and everyone needs a ticket to gain entry into the festival. If you plan on attending, please purchase one through our <a :href="ticket_url" target="_blank">sales site</a></strong></p>
			<p v-if="HasLodging">We are glad to see you will be joining us up in ShambhaLodging this summer! Also, don't forget to pick up your swag bag from the Main Lodging Building before leaving the farm!</p>
			<p v-if="DoesNotHaveLodging"><strong>Why not upgrade your experience with one of our ShambhaLodging packages?</strong>  Check out our <a :href="ticket_url+'/#lodging'" target="_blank"><strong>sales site</strong></a> to see the different packages available as well as the perks that come with being a Lodger.</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Messages',
		data() {
			return {
				rerenderCount: 0,
				display_messages: false,
				ticket_url: window.portal.ticket_url
			}
		},
		computed: {
			ticket_count: function () {
				let { Ticket: tickets = 0 } = window.portal.creds.credentials.reduce(function(obj, v) { obj[v.type] = (obj[v.type] || 0) + 1; return obj; }, {});
				return tickets;
			},
			lodging_count: function () {
				let { Lodging: lodging = 0 } = window.portal.creds.credentials.reduce(function(obj, v) { obj[v.type] = (obj[v.type] || 0) + 1; return obj; }, {});
				return lodging;
			},
			addon_count: function () {
				let { AddOn: addon = 0 } = window.portal.creds.credentials.reduce(function(obj, v) { obj[v.type] = (obj[v.type] || 0) + 1; return obj; }, {});
				return addon;
			},
			HasLodgingNoTickets: function () {
				if (this.lodging_count > 0 && this.ticket_count < 1) { return true; } else { return false; }
			},
			HasLodging: function () {
				if (this.lodging_count > 0) { return true; } else { return false; }
			},
			DoesNotHaveLodging: function () {
				if (this.lodging_count < 1) { return true; } else { return false; }
			},
		},
		mounted: function() {
			window.portal.messages = {};
			window.portal.messages.reload = this.ReloadMessages;
			this.ReloadMessages();
		},
		methods: {
			ReRender() {
				this.rerenderCount += 1;
			},
			ReloadMessages() {
				this.display_messages = false;
				this.display_messages = true;
				this.ReRender();
			},
		}
	}
</script>

<style>
	#Messages p { font-size: 13px; border-bottom: 1px solid var(--box-divider); padding-bottom: 10px; }
	.extra-strong { display: block; font-weight: bold; color: var(--box-header-color); text-align: center; font-size: 14px !important; }
	.extra-strong a { text-decoration: underline; color: #000; }
	.extra-strong a:hover { text-decoration: underline; color: var(--link-color-hover) !important; }
</style>